<template>
  <a v-if="isExternalLink" v-bind="$attrs" :href="to">
    <slot />
  </a>
  <router-link v-else v-bind="$props">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: 'bpc-router-link',
  inheritAttrs: false,

  props: {
    inactiveClass: String,
    to: String,
  },

  computed: {
    isExternalLink() {
      return (
        (typeof this.to === 'string' && this.to.startsWith('http')) ||
        this.to.startsWith('/web') ||
        this.to.startsWith('web')
      );
    },
  },
};
</script>
